const styles = {
  container: {
    display: 'flex',
    width: '100%'
  }
}

export default styles
